import { useState } from "react";
import React from "react";
import Sidebar from "../../utils/Sidebar";
import Topbar from "../../utils/Topbar";
import SuperSocialMediaLeadsContent from "../../adiComponent/Super-Admin/SuperSocialMedia/SuperSocialMediaLeadsContent";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../store/UiSlice";

const SuperSocialMediaLeads = () => {
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);

  return (
    <div>
      <div className="flex min-h-screen w-full">
        {/* Sidebar */}
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={() => dispatch(toggleSidebar())}
        />

        {/* Main Content */}
        <div className={`main-content transition-all w-full duration-300`}>
          <Topbar isSidebarOpen={isSidebarOpen} />
          <div className=""></div>

          <SuperSocialMediaLeadsContent isSidebarOpen={isSidebarOpen} />
        </div>
      </div>
    </div>
  );
};
export default SuperSocialMediaLeads;
